import { render } from "./TosFooter.vue?vue&type=template&id=38344c3c"
import script from "./TosFooter.vue?vue&type=script&lang=js"
export * from "./TosFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__